import React, { useEffect, useState } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

export default function Config() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    microsoftTeams.app.initialize()
      .then(() => {
        microsoftTeams.pages.config.setValidityState(true);

        microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
          const baseUrl = window.location.origin;
          microsoftTeams.pages.config.setConfig({
            websiteUrl: baseUrl,
            contentUrl: baseUrl + '/',
            entityId: 'protegrity-it-onboarding-' + Date.now(),
            suggestedDisplayName: 'IT Onboarding',
          })
            .then(() => saveEvent.notifySuccess())
            .catch((err) => saveEvent.notifyFailure(err.message || 'Configuration failed'));
        });

        setReady(true);
      })
      .catch((err) => {
        setError('Failed to initialize Teams: ' + err.message);
        console.error('Teams init error:', err);
      });
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '24px',
      background: '#f3f2f1',
      fontFamily: "'Segoe UI', -apple-system, sans-serif",
      textAlign: 'center',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 8,
        padding: '32px 28px',
        maxWidth: 480,
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        border: '2px solid #6264a7',
      }}>
        <div style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: '#6264a7',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 32,
          fontWeight: 700,
          margin: '0 auto 16px',
        }}>
          P
        </div>

        <h2 style={{
          fontSize: 20,
          fontWeight: 700,
          color: '#201f1e',
          marginBottom: 8,
        }}>
          IT Onboarding Checklist
        </h2>

        <p style={{
          fontSize: 13,
          color: '#605e5c',
          marginBottom: 20,
          lineHeight: 1.5,
        }}>
          A step-by-step guided checklist for IT onboarding of new Protegrity employees.
        </p>

        {error ? (
          <div style={{
            background: '#fde7e9',
            border: '1px solid #d83b01',
            borderRadius: 6,
            padding: '10px 14px',
            color: '#a4262c',
            fontSize: 12.5,
            marginBottom: 14,
          }}>
            Error: {error}
          </div>
        ) : ready ? (
          <div style={{
            background: '#dff6dd',
            border: '1px solid #107c10',
            borderRadius: 6,
            padding: '10px 14px',
            color: '#0e6b0e',
            fontSize: 12.5,
            marginBottom: 14,
            fontWeight: 600,
          }}>
            Ready to add - click Save below
          </div>
        ) : (
          <div style={{
            fontSize: 12.5,
            color: '#8a8886',
            marginBottom: 14,
          }}>
            Initializing Teams connection...
          </div>
        )}

        <div style={{
          background: '#f3f2f1',
          borderRadius: 6,
          padding: '12px 14px',
          fontSize: 11.5,
          color: '#605e5c',
          textAlign: 'left',
          lineHeight: 1.6,
        }}>
          <div style={{ fontWeight: 700, marginBottom: 6, color: '#201f1e' }}>
            What this app does:
          </div>
          - Shows 14 onboarding topics with step-by-step instructions<br/>
          - Includes Windows / MacBook OS toggle<br/>
          - Provides quick links to portals<br/>
          - Tracks progress during the call<br/>
          - Sends summary email at the end
        </div>
      </div>
    </div>
  );
}
